import { memo } from 'react'
import { Badge } from '@components/primitives/Badge.js'
import { formatCurrency, formatDate } from '@utils/format.js'
import type { OrcamentoMaterial } from '@services/db.js'

const STATUS_LABEL: Record<string, string> = {
  rascunho: 'Rascunho',
  cotado: 'Cotado',
  escolhido: 'Escolhido',
  comprado: 'Comprado',
}

type Props = {
  item: OrcamentoMaterial
  onNf?: () => void
  onPagar?: () => void
  onDelete: () => void
}

export const CotacaoRow = memo(function CotacaoRow({ item, onNf, onPagar, onDelete }: Props) {
  const metaParts = [formatDate(item.data), item.descricao].filter(Boolean)
  const isChosen = item.status === 'escolhido' || item.status === 'comprado'
  const hasNf = Boolean(item.documentoId)
  const showNf = isChosen && onNf

  return (
    <div className='cf3-mat-row' aria-label={`Cotação: ${item.fornecedor}`}>
      <div className='cf3-mat-row__icon' aria-hidden>
        {item.fornecedor.trim().charAt(0).toUpperCase() || 'F'}
      </div>

      <div className='cf3-mat-row__grid'>
        <div className='cf3-mat-row__line'>
          <span className='cf3-mat-row__titulo' title={item.fornecedor}>
            {item.fornecedor}
          </span>
          <span className='cf3-mat-row__valor'>{formatCurrency(item.valorTotal)}</span>
        </div>
        <div className='cf3-mat-row__line cf3-mat-row__line--sub'>
          <span className='cf3-mat-row__meta' title={metaParts.join(' · ')}>
            {metaParts.join(' · ')}
          </span>
          <div className='cf3-mat-row__tail'>
            <Badge
              label={STATUS_LABEL[item.status] ?? item.status}
              variant={isChosen ? 'success' : 'default'}
              size='sm'
            />
            <div className='cf3-mat-row__actions'>
              {onPagar && (
                <button
                  type='button'
                  className='cf3-mat-row__btn cf3-mat-row__btn--accent'
                  onClick={onPagar}
                >
                  Paguei
                </button>
              )}
              {showNf && (
                <button
                  type='button'
                  className='cf3-mat-row__chip-btn'
                  onClick={onNf}
                  aria-label={hasNf ? 'Ver ou trocar nota fiscal' : 'Anexar nota fiscal'}
                >
                  <Badge
                    label={hasNf ? 'Ver NF' : 'Anexar NF'}
                    variant={hasNf ? 'success' : 'default'}
                    size='sm'
                  />
                </button>
              )}
              <button
                type='button'
                className='cf3-mat-row__btn cf3-mat-row__btn--danger'
                onClick={onDelete}
                aria-label={`Excluir cotação de ${item.fornecedor}`}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
